<template>
  <div>
    <AppHeader title="实验许可管理"/>
    <Panel class="tabs search-panel" :title="false">
      <div slot="content">
        <div class="line">
          <input class="line-input" id="eqName"  v-model="nameLike"
                 placeholder="仪器名称、简介"/>
          <input class="line-input mt10" id="userName" v-model="userName" placeholder="申请人"/>
          <div class="flex-dir-row mt10">
            <div class="flex-item-auto">
              <input class="line-input" id="status" @click="showStatus" v-model="statusText" @keydown="preventDefault"
                     placeholder="状态"/>
            </div>
            <div class="btn btn-small green ml5" @click="reset">重设</div>
            <div class="btn btn-small green ml5" @click="initLicenses">查询</div>
          </div>
        </div>
      </div>
    </Panel>
    <Panel class="tabs mt15" :title="false">
      <div slot="content" class="status-content" v-infinite-scroll="loadLicenses"
           infinite-scroll-disabled="loading"
           infinite-scroll-distance="10">
        <div class="line" v-for="(lic,idx) of licenses" style="position: relative;overflow: hidden">
          <div :class="`license-status ${lic.statusClass}`">{{ lic.statusText }}</div>

          <div class="flex-dir-row">
            <div class="line-label">仪器名称：</div>
            <span v-if="lic.equipment!=null">{{ lic.equipment.name }}</span>
            <span v-else-if="lic.equipmentGroup!=null">{{ lic.equipmentGroup.name }}</span>
          </div>

          <div class="flex-dir-row">
            <div class="line-label">申请人：</div>
            {{ lic.user.realName }}
          </div>

          <div class="flex-dir-row">
            <div class="flex-dir-row flex-item-auto">
              <div class="line-label">申请时间：</div>
              {{ dateFormat(lic.createAt) }}
            </div>
            <div class="flex-dir-row">
              <div v-if="lic.status==0" class="btn btn-xsmall red" @click="changeStatus(lic, 3)">冻结</div>
              <template v-if="lic.status==2">
                <div class="btn btn-xsmall green" @click="changeStatus(lic, 0)">同意</div>
                <div class="btn btn-xsmall red ml5" @click="changeStatus(lic, 5)">拒绝</div>
              </template>
              <div v-if="lic.status==3" class="btn btn-xsmall dark-blue" @click="changeStatus(lic, 0)">解冻</div>
              <div v-if="lic.status==5" class="btn btn-xsmall dark-blue" @click="changeStatus(lic, 0)">激活</div>
            </div>
          </div>
        </div>
        <div class="line text-center" v-if="licenses.length===0">暂无记录</div>
      </div>
    </Panel>

    <mt-datetime-picker
        v-model="dateVal"
        type="datetime"
        @confirm="handleConfirm"
        ref="picker"
    >
    </mt-datetime-picker>

    <mt-popup
        v-model="equipmentsVisible"
        position="bottom"
    >
      <mt-picker :slots="equipmentSlots" @change="onEquipmentChange" value-key="text"
                 v-if="equipmentsVisible"></mt-picker>
    </mt-popup>

    <mt-popup
        v-model="statusVisible"
        position="bottom"
    >
      <mt-picker :slots="statusSlots" @change="onStatusChange" value-key="text"
                 v-if="statusVisible"></mt-picker>
    </mt-popup>

  </div>
</template>

<style lang="scss">
.license-status {
  left: 0;
  top: 0;
  position: absolute;
  font-size: 10px;
  text-align: center;
  color: #fff;
  padding: 0 10px;
  opacity: .9;
  width: 50px;
  height: 20px;
  line-height: 20px;
  border-bottom-right-radius: 6px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, .1);

  &.license {
    background: #3b5998;
  }

  &.doing {
    background: #8CC152;
  }

  &.cancel {
    background: #434A54;
  }

  &.finish {
    background: #3b5998;
  }
}
</style>

<script>
import AppHeader from "@/components/AppHeader";
import Panel from "@/components/Panel";
import {InfiniteScroll, DatetimePicker, Picker, MessageBox, Toast} from 'mint-ui';
import {mapState} from 'vuex'

export default {
  components: {
    AppHeader,
    Panel,
    InfiniteScroll,
    DatetimePicker,
    Picker
  },
  data() {
    return {
      page: 1,
      licenses: [],
      loading: false,
      noMore: false,
      beginAt: null,
      endAt: null,
      equipment: null,
      nameLike: null,
      nameLike: '',
      equipmentId: null,
      userName: null,

      dateVal: new Date(),
      pickerField: '',

      equipmentsVisible: false,
      statusVisible: false,

      statusText: '',
      status: -1,
      statusSlots: [{values: [{id: 0, text: '审核通过'}, {id: 2, text: '待审核'}, {id: 3, text: '已冻结'}, {id: 5, text: '已拒绝'}]}]
    }
  },
  computed: mapState({
    // 为了能够使用 `this` 获取局部状态，必须使用常规函数
    equipmentSlots(state) {
      return [{values: state.equipments}]
    }
  }),
  methods: {
    onEquipmentChange(picker, values) {
      this.equipment = values[0].text
      this.equipmentId = values[0].id
    },
    onStatusChange(picker, values) {
      this.statusText = values[0].text
      this.status = values[0].id
    },
    showEquipments() {
      this.equipmentsVisible = true
    },
    showStatus() {
      this.statusVisible = true
    },
    handleConfirm(value) {
      if (this.pickerField === 'beginAt') {
        this.beginAt = this.$moment(value).valueOf()
      } else {
        this.endAt = this.$moment(value).valueOf()
      }
    },
    reset() {
      this.page = 1
      this.loading = false
      this.beginAt = null
      this.endAt = null
      this.userName = ''
      this.equipment = ''
      this.equipmentId = ''
      this.status = -1
      this.statusText = ''
    },
    dateFormat(timestamp) {
      if (timestamp) {
        return this.$moment(timestamp).format('YYYY-MM-DD HH:mm')
      }
      return ''
    },
    initLicenses() {
      this.licenses = []
      this.page = 1
      this.noMore = false
      this.loadLicenses()
    },
    wrapLic(lic){
      if (lic.status === 0) {
        lic.statusText = '通过'
        lic.statusClass = 'license'
        lic.cancelable = true
      } else if (lic.status === 2) {
        lic.statusText = '待审核'
        lic.statusClass = 'doing'
      } else if (lic.status === 3) {
        lic.statusText = '已冻结'
        lic.statusClass = 'cancel'
      } else if (lic.status === 5) {
        lic.statusText = '已拒绝'
        lic.statusClass = 'finish'
      }
      return lic
    },
    loadLicenses() {
      if (this.noMore) {
        return
      }
      const that = this
      this.loading = true
      let data = new FormData()
      data.append('page', `${this.page}`)
      data.append('limit', '20')
      data.append('orderByBeginAtDesc', 'true')

      data.append('nameLike',`${this.nameLike}`)
      this.equipmentId && data.append('equipmentId', this.equipmentId)
      this.userName && data.append('userName', `${this.userName}`)
      this.status >= 0 && data.append('status', `${this.status}`)
      //?orderByBeginAtDesc=true&page=1&limit=10&equipmentId=&userId=&beginAt=&endAt=&deptId=&advisorId=&status=
      that.$http.post('/portal/licence/query', data).then(res => {
        if (res.data && res.data.length > 0) {
          const licenses = res.data.map(lic => {
            return that.wrapLic(lic)
          })
          that.licenses = that.licenses.concat(licenses)
          that.loading = false
          that.page = that.page + 1
        } else {
          this.noMore = true
        }
      })
    },
    preventDefault(e) {
      e.preventDefault()
    },
    changeStatus(lic, status) {
      const that = this
      MessageBox.confirm('确定进行此项操作?').then(action => {
        that.$http.post(`/portal/licence/changeStatus?id=${lic.id}&status=${status}`).then(res => {
          that.initLicenses()
        })
      })
    }
  },
  mounted() {
    this.initLicenses()
  }
}
</script>

